'use strict';
/*
    Tracks focus on a form field for validation.
*/
namespace TR {

    class FocusTracker {

        static lastField: any;

        field: any;
        el: JQuery;
        focusTracker: string;

        constructor (
            private $scope,
            private $element,
            private $parse,
            private $timeout
        ) {
            $scope.$on('$destroy', () => {
                this.deregister();
                FocusTracker.lastField = null;
            });
        }

        // May be called manually i.e. if form field is in a different scope
        init (el: JQuery = this.$element): void {
            let field = this.field =
                this.$parse(this.focusTracker)(this.$scope);

            if (field) {
                // Handle for some places where `controllerAs` var not available
                this.field.ft = this.$scope.ft;

                if (this.el) {
                    this.deregister();
                }
                this.el = el
                    .focus(() => this.focusHandler())
                    .blur(() => this.blurHandler());
            }
        }

        focusHandler (): void {
            this.$timeout(() => {
                this.field.focused = true;
                this.setLastField();
            });
        }

        blurHandler (): void {
            this.$timeout(() => {
                this.field.focused = false;
            });
        }

        setLastField (): void {
            if (FocusTracker.lastField) {
                FocusTracker.lastField.lastFocused = false;
            }
            this.field.lastFocused = true;
            FocusTracker.lastField = this.field;
        }

        deregister (): void {
            if (this.el) {
                this.el.off('focus blur');
            }
        }

    }

    angular
        .module('TR')
        .directive('focusTracker', (): ng.IDirective => {
            return {
                restrict: 'A',
                controller: FocusTracker,
                controllerAs: 'ft',
                bindToController: {
                    focusTracker: '@'
                },
                link: (scope: any) => {
                    scope.ft.init();
                }
            };
        });
}
